import React, { Component } from 'react';
import mp4 from '../videos/converter.mp4';

class Mp4to3 extends Component{

render(){

    return(
    <div className="project-page">
            <h1 className="project-heading">Mp4 to Mp3 converter</h1>
            <video controls>
            <source src={mp4} type="video/mp4"/>
            Your browser does not support the video tag.
            </video>
        <div className="project-text">
        <h4>Introduction</h4>
        <p>This is an mp4 to mp3 converter which can be used to convert an mp4 file that has been legally downloaded 
from a website in a manner which does not violate that website's, or any website's, terms of use and 
converts it to an mp3 file.</p>

<h4>The internals</h4>
<p>The project is divided into 3 classes namely: MainFrame, Input Form and Video Processor. 
The main function of the Main Frame is to initialise the main window or frame and call the Input Form 
class. The reason for having a whole class dedicated to this task is simply because different types of 
conversion and GUI implementations were tried and this class was used to call the different classes. The 
Main Frame also includes an output panel that lists the progress of the conversion process.
The Input Form class creates the GUI for the application which includes: The Choose Mp4 button which is 
used to select the mp4 file that is to be converted, note that the original mp4 file is left intact and 
does not undergo any changes, it's information is simply converted to mp3 and a new mp3 file is created 
from that process.
The MP3 filename input field is used to set a name for the newly created mp3 file, the program will not 
allow the user to proceed without choosing a name.
The Choose MP3 Folder button allows the user to choose the destination folder where the newly created mp3 
file will reside.
The Start button calls the Video processor class specifically the processor function which begins the 
conversion.
The Video Processor class is where the magic happens. The main function invokes the Main class and sets 
the main window properties. 
The fileChooserMP4 function uses JfileChooser to open a file chooser dialog and only accept mp4 files.
The fileChooserMP3 function uses JFileChooser to open a file chooser dialog and accepts file directories. 
The processor class initialises a Logger then tries the following: Create a Process and execute an ffmpeg 
convert command using the source mp4 file and destination mp3 file. A Buffered reader is created to get 
the error stream of the above process. While the BufferedReader is not null what ever is in the buffered 
reader gets output to the MainFrame output panel. Once the Process has completed, out put a completed 
line to the output panel then close the Process. If there is an error with the above process catch it and 
Log it.</p>

<h4>Process Flow </h4>
<p>The Gui of this program makes it straight forward to use. Click on the Choose MP4 button to select the 
MP4 that you would like to convert to MP3. Choose and type a name for the newly created MP3 file. Choose 
a folder where your newly created MP3 file will reside. Then click the start button to begin the 
conversion process. Once done the output panel will display "Video converted successfully".</p>

<h4>Conclusion</h4>
<p>ffmpeg is a powerful video processing library and has found many commercial uses as even Youtube is know 
to use it for it's videos. Though it is not called as a library it is still called as a windows command 
to convert our MP4 file to MP3. I would definitely add a better GUI to this program as the stock JFrame 
layout and buttons look a bit dreary and dated.</p>
        </div>
    </div>
    )
}

}

export default Mp4to3;